import t from "./index822.js";
function e(a, r) {
  return t(a, r);
}
export {
  e as default
};
